export default defineNuxtRouteMiddleware(() => {
	const { role } = useAuth()
	if (role.value !== 'guest') return
	return abortNavigation()
})
